<template>
    <div>
        <div class="landing__main p--0">
            <div class="landing__main__bg relative bg-main">
                <LandingHeader page-type="home" class="pt--15" />
                
                <div class="landing__main__bg__inner landing-px-2">
                    <div id="hero" class="landing__hero__wrap landing__section mb--45 mt--30">
                        <div class="landing__hero__wrap__text landing__hero__fadeFirst">
                            <h1 class="landing__hero__title text--heading text--7xl">
                                About Ziner
                            </h1>
                            <p class="landing__hero__text text-left w-100">
                                What started out as a hobby project to <a href="https://www.uzoamakaanyanwu.com/posts/building-ziner/overview" class="text--color-primary text--underline text--medium" target="_blank">solve a personal problem</a> has morphed; enough to open it to the public.
                            </p>

                            <p class="landing__hero__text mt-3 text-left w-100">
                                A key focus of Ziner is to provide freelancers, influencers and anyone who works digitally, a solution to juggling <strong>multiple tools</strong> and <strong>never ending manual data sync</strong>.  
                            </p>

                            <p class="landing__hero__text mt-3 text-left w-100">
                                Our solution: <strong>have everything you need for digital work in one place</strong>. A central platform of features and integrations designed to boost your productivity as an individual who needs to keep track of things as they work digitally. 
                            </p>

                            <p class="landing__hero__text mt-3 text-left w-100">
                                Ziner has been carefully designed to help you manage your clients, projects, invoices, rate cards, and via integrations, most things you need for digital work. As a bonus, we added you a way to <strong>publicly curate and showcase your portfolio</strong> to both potential leads and clients.
                            </p>

                            <p class="landing__hero__text mt-3 text-left w-100">
                                We put a lot of work into making this and we hope you, our user, gets everything you are looking for out of this tool.
                            </p>

                            <p class="landing__hero__text mt-3 text-left w-100">
                                Thanks for choosing Ziner!
                            </p>
                        </div>
                    </div>
                </div>

                <LandingFooter id="footer" class="mt-3" />
            </div>
            <div />
        </div>
    </div>
</template>

<script>
import LandingFooter from "@/components/home/LandingFooter.vue";
import LandingHeader from "@/components/home/LandingHeader.vue";

export default {
    name: "AboutUs",

    components: {
        LandingFooter,
        LandingHeader,
    },
};
</script>

<style lang="scss" scoped>
    .landing__hero__text p {
        font-size: 1.115rem !important;
    }
</style>